import React from "react";

const FeedFactoryIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.604"
    height="18.45"
    viewBox="0 0 20 20"
  >
    <g
      id="FabricaDeRacao"
      fill="none"
      stroke="#383838"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Galpão */}
      <rect id="Galpao" x="2" y="9" width="16" height="8" />
      {/* Chaminés */}
      <rect id="Chamine_1" x="5" y="4" width="2" height="5" />
      <rect id="Chamine_2" x="12" y="2" width="2" height="7" />
      {/* Fumaça */}
      <circle id="Fumaca_1" cx="6" cy="2.2" r="0.9" />
      <circle id="Fumaca_2" cx="7.4" cy="0.7" r="0.7" />
      <circle id="Fumaca_3" cx="13" cy="0.3" r="0.9" />
      {/* Porta */}
      <rect id="Porta" x="9" y="13" width="2" height="4" />
      {/* Janelas */}
      <rect id="Janela_1" x="4" y="11.2" width="2" height="1.6" />
      <rect id="Janela_2" x="14" y="11.2" width="2" height="1.6" />
      {/* Solo */}
      <line id="Solo" x1="1" y1="17" x2="19" y2="17" />
    </g>
  </svg>
);

export default FeedFactoryIcon;
